import React from "react";
import "./key-features.css";

// Updated list of features with more attractive and relatable icons
const features = [
  {
    // A light bulb for a bright idea/innovation
    icon: "💡",
    title: "Innovative Solutions",
    desc: "Cutting-edge solutions tailored to your business needs.",
  },
  {
    // A rocket to symbolize speed and acceleration
    icon: "🚀",
    title: "Fast & Reliable",
    desc: "Services that are fast, secure, and highly reliable.",
  },
  {
    // A lock for strong security and trust
    icon: "🔒",
    title: "Secure & Trusted",
    desc: "Your data is our top priority. Fully protected.",
  },
  {
    // A map/location pin for global access/reach
    icon: "📍",
    title: "Global Reach",
    desc: "Accessible worldwide with local support in every region.",
  },
];

const KeyFeatures = () => {
  return (
    <section className="kf-section">
      <div className="kf-background"></div>
      <h2 className="kf-title">Key Features</h2>
      <div className="kf-container">
        {features.map((feature, i) => (
          <div
            key={i}
            className={`kf-card kf-card-${i % 2 === 0 ? "left" : "right"}`}
          >
            <div className="kf-card-icon">{feature.icon}</div>
            <div className="kf-card-content">
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KeyFeatures;